import React, { useState } from 'react';
import { useInView } from '../useInView';
import { FaInstagram, FaWhatsapp, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock } from 'react-icons/fa';

export default function Contact() {
  const [form, setForm] = useState({ name: '', phone: '', product: 'Non-Woven D-Cut Bags', qty: '' });
  const [ref, v] = useInView();

  const openMaps = () => window.open('https://www.google.com/maps/search/Laxmi+Printers+Hyderabad+Telangana', '_blank');

  const sendWA = () => {
    if (!form.name || !form.phone) { alert('Please fill in your name and phone number.'); return; }
    const msg = encodeURIComponent(`Hi Laxmi Printers!\n\nName: ${form.name}\nPhone: ${form.phone}\nProduct: ${form.product}\nQuantity: ${form.qty || 'Not specified'}\n\nPlease share pricing. Thank you!`);
    window.open(`https://wa.me/916302362758?text=${msg}`, '_blank');
  };

  return (
    <>
      <style>{`
        .cc-row:hover { border-color:rgba(200,137,58,0.4)!important; background:rgba(200,137,58,0.06)!important; transform:translateX(5px); }
        .enq-input:focus { border-color:#c8893a!important; background:rgba(200,137,58,0.05)!important; outline:none; }
        .send-btn:hover { box-shadow:0 12px 40px rgba(37,211,102,0.5)!important; transform:translateY(-2px)!important; }
        .map-btn:hover { box-shadow:0 12px 40px rgba(200,137,58,0.5)!important; transform:translateY(-2px)!important; }
        @keyframes ringPulse { 0%{transform:scale(1);opacity:0.6} 100%{transform:scale(2.5);opacity:0} }
        .ring1 { animation: ringPulse 2s ease-out infinite; }
        .ring2 { animation: ringPulse 2s ease-out 0.5s infinite; }
        .ring3 { animation: ringPulse 2s ease-out 1s infinite; }
        @media(max-width:900px){ .contact-grid{grid-template-columns:1fr!important;} }
        @media(max-width:600px){
          .contact-title { font-size:clamp(28px,8vw,42px)!important; }
          .contact-sub { font-size:15px !important; line-height:1.6 !important; }
          .cc-row { padding:16px !important; }
          .enq-form { padding:24px !important; }
          .ring1, .ring2, .ring3 { display: none !important; }
        }
      `}</style>
      <section id="contact" style={s.section}>
        <div style={s.bgGlow} />
        <div style={s.container}>
          <div ref={ref} style={{ ...s.header, opacity: v ? 1 : 0, transform: v ? 'none' : 'translateY(24px)', transition: 'all 0.7s ease' }}>
            <div style={s.tagLine}><span style={s.dash} /><span style={s.tag}>CONTACT US</span><span style={s.dash} /></div>
            <h2 className="contact-title" style={s.title}>Get In Touch —<br /><em style={s.titleItalic}>We Respond Fast!</em></h2>
            <p className="contact-sub" style={s.sub}>Call us, WhatsApp us, or visit our location in Hyderabad.</p>
          </div>

          <div className="contact-grid" style={s.grid}>

            {/* LEFT — contact info */}
            <div style={{ opacity: v ? 1 : 0, transform: v ? 'none' : 'translateX(-30px)', transition: 'all 0.7s ease 0.1s' }}>
              {/* Contact rows */}
              {[
                { icon: <FaPhoneAlt style={{ fontSize: 20, color: '#27ae60' }} />, label: 'M Pradeep Kumar (Founder & Owner)', val: '+91 9959650765', btn: 'Call', color: '#27ae60', action: () => window.open('tel:+919959650765') },
                { icon: <FaPhoneAlt style={{ fontSize: 20, color: '#2563a8' }} />, label: 'M Yashwanth Kumar (Co-Owner)', val: '+91 6302362758', btn: 'Call', color: '#2563a8', action: () => window.open('tel:+916302362758') },
                { icon: <FaWhatsapp style={{ fontSize: 24, color: '#25D366' }} />, label: 'WhatsApp (Guidance & Orders)', val: 'M Yashwanth Kumar', btn: 'WhatsApp', color: '#25d366', action: () => window.open('https://wa.me/916302362758?text=Hi%20Yashwanth,%20I%20need%20guidance%20on%20bag%20printing%20orders') },
                { icon: <FaEnvelope style={{ fontSize: 20, color: '#ea4335' }} />, label: 'Email Us', val: 'laxmiprinters6302@gmail.com', btn: 'Email', color: '#ea4335', action: () => window.open('mailto:laxmiprinters6302@gmail.com') },
                { icon: <FaInstagram style={{ fontSize: 24, color: '#E4405F' }} />, label: 'Follow Us on Instagram', val: '@laxmiprinters_1', btn: 'Follow', color: '#E4405F', action: () => window.open('https://www.instagram.com/laxmiprinters_1?igsh=ZTV5MDlwOW1mMHBz&utm_source=qr', '_blank') },
                { icon: <FaMapMarkerAlt style={{ fontSize: 22, color: '#c8893a' }} />, label: 'Our Location', val: 'Hyderabad, Telangana, India', btn: 'Maps', color: '#c8893a', action: openMaps },
                { icon: <FaClock style={{ fontSize: 20, color: '#f39c12' }} />, label: 'Business Hours', val: 'Monday – Saturday: 11 AM - 8 PM', btn: null },
              ].map((row, i) => (
                <div key={i} className="cc-row" style={s.ccRow} onClick={row.action || undefined}>
                  <div style={s.ccIconWrap}>{row.icon}</div>
                  <div style={s.ccInfo}>
                    <div style={s.ccLabel}>{row.label}</div>
                    <div style={s.ccVal}>{row.val}</div>
                  </div>
                  {row.btn && (
                    <button style={{ ...s.ccBtn, background: row.color }}>{row.btn}</button>
                  )}
                </div>
              ))}

              {/* Map card */}
              <div style={s.mapCard} onClick={openMaps}>
                <div style={s.mapVisual}>
                  <div style={{ position: 'relative', zIndex: 2 }}>
                    <div style={s.mapPin}><FaMapMarkerAlt style={{ fontSize: 44, color: '#c8893a' }} /></div>
                    <div className="ring1" style={s.ring} />
                    <div className="ring2" style={s.ring} />
                    <div className="ring3" style={s.ring} />
                  </div>
                </div>
                <div style={s.mapInfo}>
                  <div style={s.mapShop}>
                    <FaMapMarkerAlt style={{ fontSize: 18, marginBottom: -2, marginRight: 4, color: '#c8893a' }} />
                    Laxmi Printers
                  </div>
                  <div style={s.mapAddr}>Hyderabad, Telangana, India</div>
                    <button className="map-btn" style={s.mapBtn}>
                      <FaMapMarkerAlt style={{ fontSize: 16, marginRight: 8 }} />
                      Open in Google Maps
                    </button>
                </div>
              </div>
            </div>

            {/* RIGHT — enquiry form */}
            <div style={{ ...s.formBox, opacity: v ? 1 : 0, transform: v ? 'none' : 'translateX(30px)', transition: 'all 0.7s ease 0.2s' }}>
              <div style={s.formHeader}>
                <h3 style={s.formTitle}>Quick Enquiry Form</h3>
                <p style={s.formSub}>Fill the form and we'll send you pricing via WhatsApp instantly.</p>
              </div>
              <div style={s.formBody}>
                {[
                  { label: 'Your Name *', id: 'name', type: 'text', placeholder: 'Enter your name' },
                  { label: 'Phone Number *', id: 'phone', type: 'tel', placeholder: '+91 your number' },
                  { label: 'Approx Quantity', id: 'qty', type: 'text', placeholder: 'e.g. 1000 pieces' },
                ].map(f => (
                  <div key={f.id} style={s.field}>
                    <label style={s.fieldLabel}>{f.label}</label>
                    <input
                      className="enq-input"
                      type={f.type}
                      placeholder={f.placeholder}
                      value={form[f.id]}
                      onChange={e => setForm(p => ({ ...p, [f.id]: e.target.value }))}
                      style={s.input}
                    />
                  </div>
                ))}
                <div style={s.field}>
                  <label style={s.fieldLabel}>Product Required</label>
                  <select
                    className="enq-input"
                    style={s.select}
                    value={form.product}
                    onChange={e => setForm(p => ({ ...p, product: e.target.value }))}
                  >
                    {['Non-Woven D-Cut Bags','Printed Plastic Carry Bags','Shopping Bags'].map(o => (
                      <option key={o}>{o}</option>
                    ))}
                  </select>
                </div>
                <button className="send-btn" style={s.sendBtn} onClick={sendWA}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, justifyContent: 'center' }}>
                    <FaWhatsapp style={{ fontSize: 20 }} /> Send Enquiry via WhatsApp
                  </span>
                </button>
                <p style={s.formNote}>
                  By submitting, you agree to be contacted on WhatsApp for pricing information.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}

const s = {
  section: { background: '#0d0d0d', padding: '120px 24px', position: 'relative', overflow: 'hidden' },
  bgGlow: {
    position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)',
    width: 800, height: 400,
    background: 'radial-gradient(ellipse, rgba(200,137,58,0.08) 0%, transparent 65%)',
    pointerEvents: 'none',
  },
  container: { maxWidth: 1280, margin: '0 auto' },
  header: { textAlign: 'center', marginBottom: 64 },
  tagLine: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 16, marginBottom: 14 },
  dash: { width: 40, height: 1, background: 'rgba(200,137,58,0.5)', display: 'inline-block' },
  tag: { fontSize: 11, letterSpacing: 4, color: '#c8893a', fontWeight: 700 },
  title: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: 'clamp(30px,4vw,52px)', fontWeight: 700,
    color: '#f0ede6', lineHeight: 1.15, marginBottom: 12,
  },
  titleItalic: { fontStyle: 'italic', color: '#c8893a' },
  sub: { fontSize: 15, color: 'rgba(240,237,230,0.5)' },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 32, alignItems: 'start' },
  ccRow: {
    display: 'flex', alignItems: 'center', gap: 14,
    background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)',
    borderRadius: 14, padding: '16px 20px', marginBottom: 10,
    cursor: 'pointer', transition: 'all 0.25s ease',
  },
  ccIconWrap: { fontSize: 22, flexShrink: 0 },
  ccInfo: { flex: 1 },
  ccLabel: { fontSize: 11.5, color: 'rgba(240,237,230,0.45)', fontWeight: 500, marginBottom: 3 },
  ccVal: { fontSize: 15, fontWeight: 700, color: '#f0ede6' },
  ccBtn: {
    border: 'none', borderRadius: 8, padding: '8px 16px',
    fontFamily: "'Outfit',sans-serif", fontWeight: 700, fontSize: 12.5,
    color: '#fff', cursor: 'pointer', flexShrink: 0,
  },
  mapCard: {
    background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(200,137,58,0.15)',
    borderRadius: 16, overflow: 'hidden', cursor: 'pointer', transition: 'all 0.25s ease',
  },
  mapVisual: {
    height: 140, background: 'linear-gradient(135deg,#0f1f18,#0a1a24)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative',
  },
  mapPin: { fontSize: 44, display: 'block', position: 'relative', zIndex: 2 },
  ring: {
    position: 'absolute', border: '1px solid rgba(200,137,58,0.4)',
    borderRadius: '50%', width: 60, height: 60,
  },
  mapInfo: { padding: '18px 20px', textAlign: 'center' },
  mapShop: {
    fontFamily: "'Cormorant Garamond',serif", fontSize: 19, fontWeight: 700,
    color: '#f0ede6', marginBottom: 4,
  },
  mapAddr: { fontSize: 13, color: 'rgba(240,237,230,0.45)', marginBottom: 14 },
  mapBtn: {
    background: 'linear-gradient(135deg,#c8893a,#e8a84a)', color: '#0a0a0a',
    border: 'none', borderRadius: 10, padding: '11px 24px',
    fontFamily: "'Outfit',sans-serif", fontWeight: 700, fontSize: 14,
    cursor: 'pointer', transition: 'all 0.25s ease', width: '100%',
    boxShadow: '0 6px 20px rgba(200,137,58,0.3)',
  },
  formBox: {
    background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)',
    borderRadius: 24, overflow: 'hidden',
  },
  formHeader: {
    padding: '28px 32px 24px',
    borderBottom: '1px solid rgba(255,255,255,0.06)',
    background: 'rgba(200,137,58,0.05)',
  },
  formTitle: {
    fontFamily: "'Cormorant Garamond',serif", fontSize: 24, fontWeight: 700,
    color: '#f0ede6', marginBottom: 6,
  },
  formSub: { fontSize: 13.5, color: 'rgba(240,237,230,0.5)' },
  formBody: { padding: '28px 32px' },
  field: { marginBottom: 18 },
  fieldLabel: { display: 'block', fontSize: 12.5, fontWeight: 600, color: 'rgba(240,237,230,0.6)', marginBottom: 7, letterSpacing: 0.3 },
  input: {
    width: '100%', padding: '13px 16px',
    background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: 10, fontFamily: "'Outfit',sans-serif", fontSize: 14,
    color: '#f0ede6', transition: 'all 0.25s ease',
  },
  select: {
    width: '100%', padding: '13px 16px',
    background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: 10, fontFamily: "'Outfit',sans-serif", fontSize: 14,
    color: '#f0ede6', transition: 'all 0.25s ease', cursor: 'pointer',
  },
  sendBtn: {
    width: '100%', background: 'linear-gradient(135deg,#25D366,#128C7E)',
    color: '#fff', border: 'none', borderRadius: 12, padding: '15px',
    fontFamily: "'Outfit',sans-serif", fontWeight: 700, fontSize: 15,
    cursor: 'pointer', transition: 'all 0.25s ease', marginBottom: 12,
    boxShadow: '0 8px 28px rgba(37,211,102,0.3)',
  },
  formNote: { fontSize: 12, color: 'rgba(240,237,230,0.3)', textAlign: 'center', lineHeight: 1.5 },
};
